import React from 'react'

export const FooterLogo = () => {
  return <>TypingMentor</>
}
